import { Outlet } from 'react-router-dom';

import Sidebar from '../sidebar';

export default function SidebarLayout() {
  return (
    <div className="flex h-full">
      <Sidebar />
      <div className="h-full flex-1">
        <Outlet />
      </div>
    </div>
  );
}
